/**
 * Dashboard Page
 */

import { useAuthStore } from '../stores/auth';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { PageHeader } from '../components/layout/PageHeader';
import { AssetStatCards } from '../components/assets/AssetStatCards';

export function DashboardPage() {
  const user = useAuthStore(s => s.user);

  return (
    <>
      <PageHeader
        title="Dashboard"
        description="Asset and workflow management overview"
        breadcrumbs={[{ label: 'Dashboard' }]}
      />

      <main className="flex-1 overflow-y-auto bg-muted/40">
        <div className="container mx-auto p-6 lg:p-8">
          <div className="flex flex-col gap-6">
            {/* Asset Stats */}
            <AssetStatCards />

            {/* Info Cards Grid */}
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
              <Card>
                <CardHeader>
                  <CardTitle>Account Details</CardTitle>
                  <CardDescription>Your current session information</CardDescription>
                </CardHeader>
                <CardContent className="flex flex-col gap-4">
                  <div>
                    <p className="text-sm/5 font-medium">Email</p>
                    <p className="text-sm/5 text-muted-foreground">{user?.email}</p>
                  </div>
                  <div>
                    <p className="text-sm/5 font-medium">Role</p>
                    <p className="text-sm/5 text-muted-foreground">{user?.role}</p>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Quick Actions</CardTitle>
                  <CardDescription>Common tasks and operations</CardDescription>
                </CardHeader>
                <CardContent className="flex flex-col gap-2">
                  {user?.role === 'Admin' && (
                    <Link to="/admin/users">
                      <Button variant="outline" className="w-full">
                        Manage Users
                      </Button>
                    </Link>
                  )}
                  <p className="text-sm/5 text-muted-foreground">Feature modules will be added here</p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Recent Activity</CardTitle>
                  <CardDescription>Latest system updates</CardDescription>
                </CardHeader>
                <CardContent>
                  <p className="text-sm/5 text-muted-foreground">Activity feed will appear here</p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
